import { sharedStrings } from "@shared/i18n/sharedStrings";

export const componentStrings = {
  app: {
    route: {
      shipments: "Shipments",
      ltl: sharedStrings.shipmentMode.ltl,
      ftl: sharedStrings.shipmentMode.ftl,
    },
    loadingLabel: "Gathering email data...",
    tabs: {
      email: "Email",
      dashboard: "Dashboard",
    },
    refresh: "Refresh",
    refreshing: "Refreshing...",
    aria: {
      viewTabs: "Switch view",
    },
    refreshConfirm: {
      title: "Refresh shipment?",
      message: "Discard unsaved changes?",
    },
    widePaneTip: "Tip: expand the apps pane for more room.",
    dismiss: "Dismiss",
    error: {
      tryAgain: "Try again",
      details: "Details",
      hideDetails: "Hide details",
    },
    placeholder: {
      noEmail: "no-email",
      session: "session",
      placeholder: "placeholder",
    },
  },
  friendlyError: {
    noItem: "Open an email to get started.",
    draft: "Open the original email in this thread, then try again.",
    notFound: "We couldn't find this email yet. Try again in a moment.",
    network: "Can't reach Load Agent right now. Try again in a moment.",
    generic: "Something went wrong. Try again.",
  },
  shipmentDashboard: {
    eyebrow: "LOAD AGENT",
    title: "Shipment Dashboard",
    loading: "Loading all shipments...",
    empty: "No shipments found.",
    clearFiltersHint: "Try clearing filters.",
    clearFilters: "Clear filters",
    filters: {
      user: "User",
      allUsers: "All users",
      customer: "Customer",
      allCustomers: "All customers",
      mode: "Mode",
      allModes: "All modes",
    },
  },
  processingMessage: {
    imageAlt: "Shipficiency",
    headingLine1: "Our Load Agent is",
    headingLine2: "analyzing your email",
    body: "Hang tight! Our Load Agent is reading through the email. This page will refresh automatically.",
    notePrefix: "If this doesn't load, open the ",
    noteHighlight: "original email",
    noteSuffix:
      " in this thread (the one the Load Agent replied to) for the add-in to work properly.",
    refreshNow: "Refresh now",
    autoRefreshIn: (seconds: number) => `Auto-refreshing in ${seconds}s`,
  },
  shipments: {
    fallback: {
      intro:
        "If the BOL didn't attach (common on Outlook desktop), download and attach it manually:",
      download: (name: string) => `Download ${name}`,
      dismiss: "Dismiss",
    },
    actions: {
      createNewQuote: "Create New Quote",
      createReply: "Create Reply",
      createReplyDisabledHint: "Select a quoted shipment",
    },
    failedHint: "Try Refresh or Create New Quote.",
    verification: {
      exactTitle: "This sender exactly matches a customer in your organization list.",
      exactAria: "Verified: sender exactly matches your customer list.",
      domainTitle: "This sender domain matches a customer in your organization list.",
      domainAria: "Verified: sender domain matches your customer list.",
      notFoundTitle:
        "This sender is not on your organization customer list. Confirm before quoting.",
      notFoundAria: "Warning: sender not found in your customer list.",
    },
    historical: {
      comingSoon: "Historical Shipment Search is coming soon!",
    },
    defaults: {
      failedBookingAdapter: "Failed to book shipment (booking adapter)",
      noSubject: "No Subject",
      companyName: "Company Name",
    },
    ignoredEmail:
      "This email was processed with no shipments detected. Use Create New Quote above to add shipments or quotes if the agent missed something.",
    processingOverlay: "Load Agent is analyzing the email",
    failedShipmentAlt: "Shipficiency",
    aria: {
      processingSkeleton: "Processing shipments",
    },
  },
  shipmentRow: {
    includeInReply: "Include in reply",
    defaults: {
      unknownTime: "Unknown time",
      statusHistoryTitle: "Status History",
      unknownUser: "Unknown user",
      noStatusHistoryRecorded: "No status history recorded.",
      noRateSelectedTitle: "No Rate Selected",
      noRateSelectedBody: "No rate selected",
      tmsPrefix: "TMS #",
      showStatusHistory: "Show status history",
      book: "Book",
      unknownLocation: "—",
    },
    aria: {
      activeOnThread: (name: string) => `Active on thread: ${name}`,
      senderVerified: "Verified: sender matches your customer list.",
      senderNotFound: "Warning: sender not on your customer sender list.",
    },
  },
  ftlPanelHeader: {
    back: "Back",
    title: "FTL Shipment",
    feedback: "Feedback",
    feedbackTitle: "Submit feedback (you can send multiple times)",
  },
  feedbackDialog: {
    title: "How did the agent perform?",
    helpText:
      "Choose thumbs up or thumbs down and add as much context as you like. You can submit feedback multiple times; each submission is saved with this email.",
    thumbsUp: "Thumbs up",
    thumbsDown: "Thumbs down",
    contextOptional: "Context (optional)",
    placeholder: "Share details, examples, or anything that helps us improve. No length limit.",
    cancel: "Cancel",
    submitting: "Submitting...",
    submitFeedback: "Submit feedback",
  },
  offerSelectionModal: {
    imageAlt: "Shipficiency",
    title: "Choose an offer to book",
    body: "You have multiple offers selected. Pick which one to use for this booking.",
    unknownCarrier: "Unknown",
    cancel: "Cancel",
    submit: "Submit",
  },
  confirmDialog: {
    confirmText: sharedStrings.actions.confirmYes,
    cancelText: sharedStrings.actions.confirmNo,
  },
} as const;
